import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'ngx-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective,
        },
    ],
    standalone: false
})
export class AutocompleteComponent implements OnInit {
  @Input() control: FormControl;
  @Input() data: Array<{ value: string, display: string }>;
  @Input() placeholder = '';
  @Output() onFilterChange: EventEmitter<any> = new EventEmitter();
  @Output() onSelected: EventEmitter<string> = new EventEmitter();

  @Input() fullWidth = false;
  constructor() {
  }

  ngOnInit() {
    this.control.valueChanges.pipe(debounceTime(400)).subscribe(value => {
      if (typeof (value) === 'string' && value !== undefined && value.trim() !== '') {
        this.onFilterChange.emit(value);
      }
    });
  }

  getOptionText(option) {
    return option != null ? option.display : null;
  }

  onSelectedOption($event) {
    this.onSelected.emit($event.value);
  }
}
